import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from './Icons.types';

const Discount = (props: IIcon) => {
  const { className = '', ...rest } = props;

  return (
    <svg
      {...rest}
      className={classNames('w-4 h-4', className)}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3089_182)">
        <path
          d="M15.2643 8.00056L15.9663 6.16969C16.0433 5.9677 15.9833 5.73872 15.8143 5.60173L14.2924 4.36781L13.9844 2.43094C13.9504 2.21696 13.7824 2.04997 13.5684 2.01597L11.6316 1.70799L10.3987 0.185095C10.2627 0.0161068 10.0287 -0.0438891 9.8317 0.0331056L7.99982 0.736058L6.16895 0.0341055C5.96596 -0.0438891 5.73898 0.0181066 5.60198 0.186095L4.36807 1.70899L2.4312 2.01697C2.21822 2.05097 2.05023 2.21896 2.01623 2.43194L1.70825 4.36881L0.185355 5.60273C0.0173667 5.73872 -0.0436291 5.9677 0.0333656 6.16969L0.735318 8.00056L0.0333656 9.83144C-0.0446291 10.0334 0.0173667 10.2624 0.185355 10.3984L1.70825 11.6313L2.01623 13.5682C2.05023 13.7822 2.21722 13.9502 2.4312 13.9842L4.36807 14.2921L5.60198 15.814C5.73898 15.984 5.96796 16.044 6.16995 15.966L7.99982 15.2651L9.8307 15.967C9.88869 15.989 9.94869 16 10.0097 16C10.1567 16 10.3017 15.935 10.3987 15.814L11.6316 14.2921L13.5684 13.9842C13.7824 13.9502 13.9504 13.7822 13.9844 13.5682L14.2924 11.6313L15.8143 10.3984C15.9833 10.2614 16.0433 10.0334 15.9663 9.83144L15.2643 8.00056Z"
          fill="#5ca34b"
        />
        <path
          d="M6.4999 7.00062C5.67295 7.00062 5 6.32766 5 5.50072C5 4.67378 5.67295 4.00082 6.4999 4.00082C7.32684 4.00082 7.99979 4.67378 7.99979 5.50072C7.99979 6.32766 7.32684 7.00062 6.4999 7.00062ZM6.4999 5.00076C6.22392 5.00076 5.99993 5.22474 5.99993 5.50072C5.99993 5.7767 6.22392 6.00069 6.4999 6.00069C6.77588 6.00069 6.99986 5.7767 6.99986 5.50072C6.99986 5.22474 6.77588 5.00076 6.4999 5.00076Z"
          fill="#FAFAFA"
        />
        <path
          d="M9.4999 12.0003C8.67295 12.0003 8 11.3273 8 10.5004C8 9.67344 8.67295 9.00049 9.4999 9.00049C10.3268 9.00049 10.9998 9.67344 10.9998 10.5004C10.9998 11.3273 10.3268 12.0003 9.4999 12.0003ZM9.4999 10.0004C9.22492 10.0004 8.99993 10.2254 8.99993 10.5004C8.99993 10.7754 9.22492 11.0004 9.4999 11.0004C9.77488 11.0004 9.99986 10.7754 9.99986 10.5004C9.99986 10.2254 9.77488 10.0004 9.4999 10.0004Z"
          fill="#FAFAFA"
        />
        <path
          d="M5.49952 12.0003C5.39853 12.0003 5.29753 11.9703 5.20954 11.9073C4.98456 11.7463 4.93256 11.4343 5.09355 11.2093L10.0932 4.20981C10.2542 3.98483 10.5662 3.93283 10.7912 4.09382C11.0161 4.25381 11.0671 4.56679 10.9072 4.79077L5.90749 11.7903C5.8085 11.9273 5.65551 12.0003 5.49952 12.0003Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_3089_182">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Discount;
